import EcoSpace from 'eco-design/base/eco-space';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useRef } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const P: React.FC = () => {
    const { t } = useLang('ats.P');
    const webpOrJpg = useWebpOrJpg('#smart-gateway-P');

    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;
        const calssArr = ['.title', '.desc', '.img-1', '.img-2', '.item-title-1', '.item-title-2'];
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                calssArr.forEach((item) => {
                    const dom = sectionRef.current?.querySelector(item);
                    if (dom) {
                        dom.classList.add('enter');
                    }
                });
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    calssArr.forEach((item) => {
                        const dom = sectionRef.current?.querySelector(item);
                        if (dom) {
                            dom.classList.remove('enter');
                        }
                    });
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} smart-gateway-P GtmModuleData-section`}
                id="smart-gateway-P"
                data-section-id={'smart-gateway-P'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div className="title ani-1">{t('title')}</div>
                <div className="desc ani-2">{t('desc')}</div>
                <div className="list">
                    <div className="item">
                        <img className="img-1 ani-3" src={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1759132078119/sgs.png')} loading="lazy" />
                        <div className="item-title item-title-1 ani-3-5">{t('item1')}</div>
                    </div>
                    <div className="item">
                        <img className="img-2 ani-3" src={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1759132077959/3r.png')} loading="lazy" />
                        <div className="item-title item-title-2 ani-3-5">{t('item2')}</div>
                    </div>
                </div>
            </section>
            <EcoSpace />
        </>
    );
};

export default P;
